<template>
  <div v-if="fullscreenEnabled">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            class="fs-toggle"
            v-bind="attrs"
            v-on="on"
            @click="toggleFullscreen"
        >
          <v-icon>
            {{ isFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ isFullscreen ? 'Kilépés' : 'Teljes képernyő' }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import screenfull from 'screenfull';

export default {
  name: 'FullScreen',
  data() {
    return {
      isFullscreen: false,
      fullscreenEnabled: screenfull.isEnabled
    };
  },
  mounted() {
    if (screenfull.isEnabled) {
      screenfull.on('change', this.updateFullscreenState);
    }
  },
  beforeDestroy() {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.updateFullscreenState);
    }
  },
  methods: {
    toggleFullscreen() {
      if (screenfull.isEnabled) {
        screenfull.toggle();
      }
    },
    updateFullscreenState() {
      this.isFullscreen = screenfull.isFullscreen;
    }
  }
};
</script>

<style scoped>
.fs-toggle {
  height: 100% !important;
}
</style>
